import {Component, Emitter} from '@wonderlandengine/api';

export class TimeManager extends Component {
    static TypeName = 'time-manager';

    // Singleton
    private static _instance: TimeManager;
    static get instance(): TimeManager {
        return TimeManager._instance;
    }

    paused = false;

    onPaused = new Emitter();
    onResumed = new Emitter();

    init() {
        if (TimeManager._instance) {
            console.error('There can only be one instance of TimeManager Component');
        }
        TimeManager._instance = this;
    }

    stopTime() {
        // Lol, now what? 😅
        this.paused = true;
        this.onPaused.notify();
    }

    resumeTime() {
        this.paused = false;
        this.onResumed.notify();
    }
}
